import i18n from '@/i18n'

type AlertContentCallback = () => void

class AlertContentFactory {
  static makeEntryContent(
    completion: AlertContentCallback,
    cancel: AlertContentCallback
  ) {
    const content = {
      content: {
        header: i18n.t('eventEntryConfirmationWithAgreement'),
      },
      alertItems: [
        {
          type: 'normal',
          title: i18n.t('buttonCancel'),
          action: cancel,
        },
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }
    return content
  }

  // エントリーしようとした時に、すでに他のスコア加算中のイベントが存在していた時
  static makeOtherScoringEventContent(
    completion: AlertContentCallback,
    cancel: AlertContentCallback
  ) {
    const content = {
      content: {
        title: i18n.t('enteredEventAlreadyExistsAlert'),
        header: i18n.t('aboutMultipleEventEntry'),
        body: `
                <p>${i18n.t('multipleEventEntryAlertDescription1')}</p>
                <p>${i18n.t('multipleEventEntryAlertDescription2')}</p>
                <p>${i18n.t('multipleEventEntryAlertDescription3')}</p>
              `,
        footer: `
                <p>${i18n.t('eventEntryConfirmationWithAgreement')}</p>
        `
      },
      alertItems: [
        {
          type: 'normal',
          title: i18n.t('buttonCancel'),
          action: cancel,
        },
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }

    return content
  }

  static makeCompletedEntryContent(
    completion: AlertContentCallback,
    isSuccess: boolean,
    errorMessage: string,
  ) {
    let header: string = ''
    let message: string = ''
    let footer: string = ''
    if (isSuccess) {
      header = `<p>${i18n.t('eventEntryCompleted')}</p>`
    } else if (errorMessage) {
      header = `<p>${i18n.t('limitedByLatestScoringEventSwitchLimit')}</p>`
      footer = `
        <p>${errorMessage}</p>
      `
    } else {
      message = `
          <p>${i18n.t('entryFailed1')}</p><br/>
          <p>${i18n.t('entryFailed2')}</p><br/>
          <p>${i18n.t('entryFailed3')}</p>
        `
    }

    const content = {
      content: {
        header: header,
        body: `${message}`,
        footer: footer,
      },
      alertItems: [
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }

    return content
  }


  static makePreEntryContent(
    completion: AlertContentCallback,
    cancel: AlertContentCallback
  ) {
    const content = {
      content: {
        header: i18n.t('aboutPreEntryEvent'),
        body: `
          <p>${i18n.t('preEntryEventDescription1')}</p>
        `,
        footer: `
          <p>${i18n.t('preEntryEventConfirmationWithAgreement')}</p>
        `
      },
      alertItems: [
        {
          type: 'normal',
          title: i18n.t('buttonCancel'),
          action: cancel,
        },
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }
    return content
  }

  static makeOverridePreEntryContent(
    events: any[],
    completion: AlertContentCallback,
    cancel: AlertContentCallback
  ) {
    const conflictedEventNames = events.map((e) => {
      return i18n.t('eventName', { eventName: e.title })
    }).join(" ")

    const content = {
      content: {
        header: i18n.t('entryConfirmHeader'),
        body: `
          <p>${i18n.t('preEntryEventDescription1')}</p>
          <p>${i18n.t('preEntryEventDescription2', { preEnteredEventNames: conflictedEventNames })}</p>
        `,
        footer: `
          <p>${i18n.t('preEntryEventConfirmationWithAgreement')}</p>
        `
      },
      alertItems: [
        {
          type: 'normal',
          title: i18n.t('buttonCancel'),
          action: cancel,
        },
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }

    return content
  }

  static makeCompletedPreEntryContent(
    completion: AlertContentCallback,
    isSuccess: boolean
  ) {
    let header: string = ''
    let message: string = ''
    if (isSuccess) {
      header = `<p>${i18n.t('preEntryEventCompleted')}</p>`
    } else {
      message = `
          <p>${i18n.t('entryFailed1')}</p><br/>
          <p>${i18n.t('entryFailed2')}</p><br/>
          <p>${i18n.t('entryFailed3')}</p>
        `
    }

    const content = {
      content: {
        header: header,
        body: `${message}`,
      },
      alertItems: [
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }

    return content
  }

  static makeConfirmCancelPreEntryContent(
    completion: AlertContentCallback,
    cancel: AlertContentCallback
  ) {
    const content = {
      content: {
        header: i18n.t('cancelEventPreEntryConfirmation'),
      },
      alertItems: [
        {
          type: 'normal',
          title: i18n.t('buttonCancel'),
          action: cancel,
        },
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }
    return content
  }

  static makeCompletedCancelPreEntryContent(
    completion: AlertContentCallback,
    isSuccess: boolean
  ) {
    const header: string = isSuccess ? `<p>${i18n.t('cancelPreEntryCompleted')}</p>` : `<p>${i18n.t('FailedToCancelEventPreEntry')}</p>`

    const content = {
      content: {
        header: header,
      },
      alertItems: [
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }
    return content
  }

  static makeSwitchingScoringEventContent(
    completion: AlertContentCallback,
    cancel: AlertContentCallback
  ) {
    const content = {
      content: {
        header: i18n.t('switchingScoringEventConfirmation'),
      },
      alertItems: [
        {
          type: 'normal',
          title: i18n.t('buttonCancel'),
          action: cancel,
        },
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }
    return content
  }

  static makeSwitchingScoringEventCompletedContent(
    completion: AlertContentCallback,
    isSuccess: boolean,
    errorMessage: string,
  ) {
    let header: string = ''
    let message: string = ''
    let footer: string = ''
    if (isSuccess) {
      header = `<p>${i18n.t('switchingScoringEventCompleted')}</p>`
    } else if (errorMessage) {
      header = `<p>${i18n.t('limitedByLatestScoringEventSwitchLimit')}</p>`
      footer = `
        <p>${errorMessage}</p>
      `
    } else {
      message = `
          <p>${i18n.t('entryFailed1')}</p><br/>
          <p>${i18n.t('entryFailed2')}</p><br/>
          <p>${i18n.t('entryFailed3')}</p>
        `
    }

    const content = {
      content: {
        header: header,
        body: message,
        footer: footer,
      },
      alertItems: [
        {
          type: 'preffered',
          title: i18n.t('buttonOK'),
          action: completion,
        },
      ],
    }

    return content
  }

  static makeHasNotAvatarEntryContent(cancel: AlertContentCallback) {
    const content = {
      content: {
        header: i18n.t('entryAvatarRequiredHeader'),
        body: `
                  <p>${i18n.t('entryAvatarRequired1')}</p><br/>
                  <p>${i18n.t('entryAvatarRequired2')}</p>
                `,
      },
      alertItems: [
        {
          type: 'normal',
          title: i18n.t('buttonOK'),
          action: cancel,
        },
      ],
    }

    return content
  }
}

export default AlertContentFactory
